var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      key: "canvas",
      ref: "frame",
      staticClass: "t-player",
      class: [{ "t-player--embed": _vm.embed }],
    },
    [
      _c("video", {
        ref: "videoElement",
        class: { "t-player__flipped": _vm.video.flipNeeded },
        attrs: {
          id: "video_player",
          preload: "auto",
          controls: _vm.$isMobile && !_vm.showPlayButton,
          poster: _vm.poster,
          autoplay: _vm.autoplay,
        },
        domProps: { muted: _vm.autoplay },
        on: {
          mousemove: _vm.mousemove,
          loadedmetadata: function ($event) {
            return _vm.videoOnLoaded($event)
          },
          loadeddata: function ($event) {
            return _vm.videoOnLoaded($event)
          },
          click: function ($event) {
            return _vm.togglePlay()
          },
          play: function ($event) {
            return _vm.play($event)
          },
          pause: function ($event) {
            return _vm.pause($event)
          },
          ended: function ($event) {
            return _vm.ended($event)
          },
          seeking: function ($event) {
            return _vm.seeking()
          },
          timeupdate: function ($event) {
            return _vm.timeupdate($event)
          },
          volumechange: function ($event) {
            return _vm.onvolumechange($event)
          },
          waiting: function ($event) {
            return _vm.waiting($event)
          },
          canplay: function ($event) {
            return _vm.canplay($event)
          },
        },
      }),
      _vm._v(" "),
      !_vm.$isMobile
        ? _c("canvas", {
            ref: "player-canvas",
            staticClass: "t-player__focus",
            style: `opacity:${_vm.paintingInProgress ? 1 : 0}`,
            attrs: { width: "800", height: "400" },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.caption && _vm.subtitleVisibility
          ? _c("div", { staticClass: "t-player__subtitles" }, [
              _c(
                "div",
                {
                  staticClass: "t-player__subtitle",
                  class: { "t-fs--h3": _vm.mode == "fullscreen" },
                },
                [
                  _c("mark", [
                    _vm._v("\n          " + _vm._s(_vm.caption) + "\n        "),
                  ]),
                ]
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        (_vm.status == "paused" && !_vm.slideMode) || _vm.buffering
          ? _c(
              "div",
              {
                key: "play-button",
                staticClass: "t-player__icon",
                on: {
                  click: function ($event) {
                    return _vm.togglePlay()
                  },
                },
              },
              [
                _vm.status == "paused"
                  ? _c("i", { staticClass: "mdi mdi-motion-play" })
                  : _c("i", {
                      staticClass: "fas fa-circle-notch fa-fw fa-spin",
                    }),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.canShowControls && !_vm.hideControls
        ? [
            _vm.canShowSlideMode && _vm.slideMode
              ? _c("slide-player-controls", {
                  attrs: {
                    status: _vm.status,
                    steps: _vm.spotLights,
                    mode: _vm.mode,
                    "subtitle-tracks": _vm.hls && _vm.hls.subtitleTracks,
                    caption: _vm.caption,
                    slide: _vm.currentSlide,
                    "hide-prev": _vm.hidePrev,
                    "hide-next": _vm.hideNext,
                    "initial-subtitle-visibility":
                      _vm.initialSubtitleVisibility,
                    "remove-trainn-branding": _vm.video.removeTrainnBrand,
                  },
                  on: {
                    play: _vm.togglePlay,
                    pause: _vm.togglePlay,
                    forward: _vm.playNext,
                    backward: _vm.playPrev,
                    exitSlideMode: _vm.exitSlideMode,
                    fullscreen: _vm.fullscreen,
                    defaultscreen: _vm.defaultscreen,
                    caption: _vm.subtitle,
                    setSubtitle: _vm.setSubtitle,
                  },
                })
              : _c("player-controls", {
                  attrs: {
                    duration: _vm.duration,
                    "current-time": _vm.currentTime,
                    status: _vm.status,
                    steps: _vm.spotLights,
                    "video-volume": _vm.volume,
                    muted: _vm.muted,
                    mode: _vm.mode,
                    chapters: _vm.video.chapters,
                    "quick-jump": _vm.quickJump,
                    "playback-speed": _vm.currentPlaybackSpeed,
                    caption: _vm.caption,
                    "subtitle-tracks": _vm.hls && _vm.hls.subtitleTracks,
                    levels: _vm.levels,
                    level: _vm.level,
                    "slide-mode-enabled": _vm.canShowSlideMode,
                    "initial-subtitle-visibility":
                      _vm.initialSubtitleVisibility,
                    "remove-trainn-branding": _vm.video.removeTrainnBrand,
                  },
                  on: {
                    play: _vm.togglePlay,
                    pause: _vm.togglePlay,
                    seek: _vm.seek,
                    volume: _vm.volumechange,
                    mute: _vm.mute,
                    unmute: _vm.unmute,
                    fullscreen: _vm.fullscreen,
                    defaultscreen: _vm.defaultscreen,
                    togglePip: _vm.togglePip,
                    forward: _vm.forward,
                    backward: _vm.backward,
                    enterSlideMode: _vm.enterSlideMode,
                    caption: _vm.subtitle,
                    playbackRate: _vm.playbackRate,
                    setSubtitle: _vm.setSubtitle,
                    setLevel: _vm.setLevel,
                  },
                }),
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.$isEmpty(_vm.relativeCtaLinks) &&
      _vm.status != "ended" &&
      !(_vm.relativeCtaLinks.length == 1 && !_vm.$isEmpty(_vm.finalCta))
        ? [
            _c("transition", { attrs: { name: "fade" } }, [
              !_vm.showAllRelativeCtaLinks
                ? _c(
                    "div",
                    { key: "info", staticClass: "t-player__rlink" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "t-player__rlink-icon",
                          on: {
                            click: function ($event) {
                              return _vm.toggleRelativeLinks()
                            },
                          },
                        },
                        [_c("i", { staticClass: "fas fa-info fa-fw" })]
                      ),
                      _vm._v(" "),
                      _c("t-slide-width", [
                        !_vm.$isEmpty(_vm.relativeCta)
                          ? _c(
                              "a",
                              {
                                key: _vm.relativeCta.value,
                                staticClass:
                                  "t-tc--primary t-player__rlink-text",
                                attrs: {
                                  href: _vm.relativeCta.value,
                                  target: "_blank",
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.relativeCta.label)),
                                ]),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass:
                                    "t-mar--l-ti t-fs--caption fas fa-external-link-alt fa-fw",
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  )
                : _c(
                    "div",
                    {
                      key: "list",
                      staticClass:
                        "t-player__rlink t-player__rlink-list t-flex--dc",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "t-player__rlink-head" },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("player.references"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "t-button",
                            {
                              attrs: { variant: "action" },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleRelativeLinks()
                                },
                              },
                            },
                            [_c("i", { staticClass: "fas fa-times fa-fw" })]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "t-list t-mar--t-no t-mar--b-no" },
                        [
                          _vm._l(_vm.uniqueRelativeCtaLinks, function (cta) {
                            return [
                              !_vm.$isEmpty(cta.data)
                                ? _c(
                                    "div",
                                    { key: cta.id, staticClass: "t-list-item" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "t-tc--primary t-player__rlink-text",
                                          attrs: {
                                            href: cta.data.value,
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(cta.data.label)),
                                          ]),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass:
                                              "t-fs--caption fas fa-external-link-alt fa-fw",
                                          }),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.status == "ended" &&
        (!_vm.$isEmpty(_vm.finalCta) || !_vm.$isEmpty(_vm.socialLinks))
          ? _c(
              "div",
              { staticClass: "t-player__cta" },
              [
                !_vm.$isEmpty(_vm.finalCta) && !_vm.$isEmpty(_vm.finalCta.data)
                  ? [
                      _c("div", [
                        _c(
                          "a",
                          {
                            staticClass: "t-tc--white",
                            attrs: {
                              href: _vm.finalCta.data.value,
                              target: "_blank",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.finalCta.data.label)),
                            ]),
                            _vm._v(" "),
                            _c("i", {
                              staticClass:
                                "t-mar--l-ti fas fa-external-link-alt fa-fw",
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "t-button",
                        {
                          key: "replay-button",
                          staticClass: "t-mar--t-xs t-tc--white t-mar--b-sm",
                          attrs: { variant: "action" },
                          on: {
                            click: function ($event) {
                              return _vm.togglePlay()
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "fas fa-redo-alt fa-fw" }),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("generic.button.replay"))),
                          ]),
                        ]
                      ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$isEmpty(_vm.socialLinks)
                  ? _c("div", { staticClass: "t-player__social" }, [
                      !_vm.$isMobile && _vm.$isEmpty(_vm.finalCta)
                        ? _c("p", { staticClass: "t-fs--h6" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("player.videos.share_text")) +
                                "\n        "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.socialLinks.linkedin
                        ? _c(
                            "a",
                            {
                              staticClass: "t-tc--white",
                              attrs: {
                                href: _vm.socialLinks.linkedin,
                                target: "_blank",
                              },
                            },
                            [_c("i", { staticClass: "fab fa-linkedin fa-fw" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.socialLinks.twitter
                        ? _c(
                            "a",
                            {
                              staticClass: "t-tc--white",
                              attrs: {
                                href: _vm.socialLinks.twitter,
                                target: "_blank",
                              },
                            },
                            [_c("i", { staticClass: "fab fa-twitter fa-fw" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.socialLinks.facebook
                        ? _c(
                            "a",
                            {
                              staticClass: "t-tc--white",
                              attrs: {
                                href: _vm.socialLinks.facebook,
                                target: "_blank",
                              },
                            },
                            [_c("i", { staticClass: "fab fa-facebook fa-fw" })]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.showSignupAtEnd && _vm.status == "ended"
        ? _c("div", { staticClass: "t-player__signupCta" }, [
            _c(
              "a",
              {
                attrs: {
                  href: "https://app.trainn.co?utm_campaign=plg&utm_source=video_embed",
                  target: "_blank",
                },
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/lib/assets/images/Trainn-Type-Assets/Trainn-type-mono.png"),
                    height: "22px",
                  },
                }),
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("player.link.signup")) + "\n    "
                ),
              ]
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }